module.exports = __webpack_public_path__ + "img/gide.791d2374.jpg";